import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServerResponse } from '../models/types';
import * as localForage from 'localforage';
import { GetLocalForageConFigService } from './getLocalForage.service';
import { async } from '@angular/core/testing';
import { Store } from '@ngrx/store';
import { KHTV_SGC, KH_HCG } from '../models/customer.model';

@Injectable()
export class CustomerService {
    getKH_HCG() {
        throw new Error('Method not implemented.');
    }
    url: any;
    constructor(
      private http: HttpClient,
      private storeKHHCG: Store<KH_HCG>,
        private getlocalconfig: GetLocalForageConFigService,
        @Inject('BASE_URL') baseUrl: string,
    ) {
        this.url = baseUrl;
    }

    async getCustomer(id: string) {
        return this.http.post(this.url + 'api/Customer/getCustomer', { Id: id })
            .toPromise()
            .then((result: ServerResponse) => {
                if (result[0].code === 1) {
                    const name = /*result[0].data['HoLot'] + ' ' + */ result[0].data['Ten'];
                    const idCus = result[0].data['MaThe13'];
                    const Score = result[0].data['Diem'];
                    const LevelName = result[0].data['TenCapDo'];
                    const IdLevel = result[0].data['MaCapDo'];
                    const dscpercent = result[0].data['TLCK'];
                    this.getlocalconfig.getConfigLocalForage()
                        .then(async result => {
                            // tslint:disable-next-line:max-line-length
                            await localForage.setItem('_customer', JSON.stringify({ MaKHTV: idCus, TenKH: name, TenCapDo: LevelName, Diem: Score, MaCapDo: IdLevel, TLCK: dscpercent })).then();
                        });
                    return Promise.resolve(result[0].code);
                } else {
                    return Promise.reject(result[0].code);
                }
            });
    }

  async getCustomer_API(id: string) {
      //Sử dụng cho SGC
      //return this.getCustomer_API_SGC(id);
      //Sử dụng cho 6.3 bên dưới
    //return this.getCustomer_API_TOPOS(id);

    //Sử dụng cho 6.3 và GM bên dưới
    return this.getCustomer(id);
  }

  async getCustomer_API_TOPOS(id: string) {
    return this.http.post(this.url + 'api/Customer/getCustomer_GMAPI', { Id: id })
      .toPromise()
      .then((result: ServerResponse) => {
        if (result[0].code === 1) {
          const name = /*result[0].data['HoLot'] + ' ' + */ result[0].data['name'];
          const idCus = result[0].data['id'];
          const Score = result[0].data['balanceAccounts'][0]['balance'];
          const LevelName = result[0].data['balanceAccounts'][0]['id'];
          const IdLevel = result[0].data['balanceAccounts'][0]['id'];
          this.getlocalconfig.getConfigLocalForage()
            .then(async result => {
              // tslint:disable-next-line:max-line-length
              await localForage.setItem('_customer', JSON.stringify({ MaKHTV: idCus, TenKH: name, TenCapDo: LevelName, Diem: Score, MaCapDo: IdLevel })).then();
            });
          return Promise.resolve(result[0].code);
        } else {
          return Promise.reject(result[0].code);
        }
      });
  }



  async getCustomer_API_SGC(id: string) {
    return this.http.post(this.url + 'api/Customer/getCustomer_SGC', { Id: id, PhoneNumber: '' })
      .toPromise()
      .then((result: ServerResponse) => {
        if (result[0].code === 1) {
          const name = /*result[0].data['HoLot'] + ' ' + */ result[0].data[0]['HoLot'] + ' ' + result[0].data[0]['Ten'];
          const idCus = result[0].data[0]['MaThe13'];
          const Score = result[0].data[0]['Diem'];
          const LevelName = result[0].data[0]['TenCapDo'];
          const IdLevel = result[0].data[0]['MaCapDo'];
          this.getlocalconfig.getConfigLocalForage()
            .then(async result => {
              // tslint:disable-next-line:max-line-length
              await localForage.setItem('_customer', JSON.stringify({ MaKHTV: idCus, TenKH: name, TenCapDo: LevelName, Diem: Score, MaCapDo: IdLevel })).then();
            });
          return Promise.resolve(result[0].code);
        } else {
          return Promise.reject(result[0].code);
        }
      });
  }

  async getCustomer_SGC(id: string, sdt: string) {
   let dsKHTV_SGC: Array<KHTV_SGC> = new Array<KHTV_SGC>();
    return this.http.post(this.url + 'api/Customer/getCustomer_SGC', { Id: id , PhoneNumber: sdt})
      .toPromise()
      .then((result: ServerResponse) => {
        if (result[0].code === 1) {
           dsKHTV_SGC = result[0].data;       
          return Promise.resolve(dsKHTV_SGC);
        } else {
          return Promise.reject(result[0].message);
        }
      });
  }

  async getCustomer_HCG() {
    return this.http.post(this.url + 'api/Customer/getCustomer_HCG', {})
      .toPromise()
      .then((result: ServerResponse) => {
        if (result[0].code === 1) {
          this.storeKHHCG.dispatch({ type: 'INIT_HCG', hcg: result[0].data });
          // console.log('getPayments');
          // console.log(result[0]);
          return Promise.resolve(result[0].data);
        } else {
          return Promise.reject(null);
        }
      });
  }

    async PointRedemp_API(id: string, amount: number,
        accountID: string, storeId: string,
        workstationID: string, receiptNumber: number) {
        return this.http.post(this.url + 'api/Customer/postRedemption_GMAPI',
            {
                Id: id, Amount: amount,
                AccountID: accountID, StoreID: storeId,
                WorkstationID: workstationID, ReceiptNumber: receiptNumber
            })
            .toPromise()
            .then((result: ServerResponse) => {
                if (result[0].code === 1) {
                    if (result[0].message === null) {
                        return Promise.resolve(result[0].data);
                    } else {
                        throw new Error(result[0].message);
                    }
                } else {
                    throw new Error("Có lỗi trong quá trình thanh toán điểm! Vui lòng thử lại sau!");
                }
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/services/customer.service.ts